module.exports = __webpack_public_path__ + "static/media/capsules.139a8c20.svg";